import { LinkButton, UIHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './RealtyCalendarBanner.css';
import { trackRealtyCalendarBannerClick } from './tracking';
import { IRealtyCalendarBannerProps } from './types';

export const RealtyCalendarBanner = (props: IRealtyCalendarBannerProps) => {
  const { helpUrl } = props;

  return (
    <div className={styles['wrapper']}>
      <div className={styles['title']}>
        <UIHeading4>Подключите объявление к RealtyCalendar</UIHeading4>
      </div>

      <div className={styles['text']}>
        <UIText2>Клиенты сразу увидят на Циан актуальные цены и свободные даты</UIText2>
      </div>

      <LinkButton
        href={helpUrl}
        target="_blank"
        onClick={trackRealtyCalendarBannerClick}
        size="XS"
        color="fill_primary"
      >
        Как подключить
      </LinkButton>
    </div>
  );
};
